import { useTranslation } from 'react-i18next';
import FieldWrapper from '../../../components/formInputs/FieldWrapper';
import { ISingleField } from '../types/interfaces';
import FormUpload from '../../../components/formInputs/FormUpload';
import { useRef } from 'react';

interface IProps {
  data: ISingleField;
  entityIndex: number;
  formik: any;
  fieldIndex: number;
  isCurrentStep: boolean;
  canEdit: boolean;
  setUnauthorized?: React.Dispatch<React.SetStateAction<boolean>>;
}

const SingleField = ({ data, entityIndex, formik, fieldIndex, isCurrentStep, canEdit, setUnauthorized }: IProps) => {
  const { i18n } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={data?.type === 'file' ? 'file' : ''} onClick={() => {
      !canEdit && setUnauthorized && setUnauthorized(true)
    }}>
      {data?.type === 'text' && (
        <FieldWrapper
          title={data?.label[i18n.language as 'ar' | 'en']}
          inputName={`entity[${entityIndex}].values[${fieldIndex}].value`}
          inputPlaceholder={data?.label[i18n.language as 'ar' | 'en']}
          inputError={formik?.errors?.entity?.[entityIndex]?.values?.[fieldIndex]?.value as string}
          inputTouched={formik?.touched?.entity?.[entityIndex]?.values?.[fieldIndex]?.value as boolean}
          input
          disabled={!isCurrentStep || !canEdit}
          ref={inputRef}
        />
      )}
      {data?.type === 'file' && (
        <FormUpload
          formik={formik}
          name={`entity.${entityIndex}.values.${fieldIndex}.value`}
          fileName={data?.document?.name}
          // fileUrl={data?.document?.url}
          disabled={!isCurrentStep || !canEdit}
          label={data?.label[i18n.language as 'ar' | 'en']}
        />
      )}
    </div>
  );
};

export default SingleField;
